/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RegistryDiscoveryMetadata,
  RegistryDiscoveryMetadata$inboundSchema,
} from "./registrydiscoverymetadata.js";

export type RegistryDiscoveryPage = {
  metadata: RegistryDiscoveryMetadata;
  /**
   * Complete registry record envelopes, including server and _meta extensions
   */
  servers: Array<any>;
};

/** @internal */
export const RegistryDiscoveryPage$inboundSchema: z.ZodMiniType<
  RegistryDiscoveryPage,
  unknown
> = z.object({
  metadata: RegistryDiscoveryMetadata$inboundSchema,
  servers: z.array(z.any()),
});

export function registryDiscoveryPageFromJSON(
  jsonString: string,
): SafeParseResult<RegistryDiscoveryPage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RegistryDiscoveryPage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegistryDiscoveryPage' from JSON`,
  );
}
